function parsePortfolioStudent(obj) {
  // Move student subproperties to main object
  return { ...obj, ...obj.student, student: undefined, disabled: !obj.portfolioEnabled };
}

export default parsePortfolioStudent;
